import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/homepage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Listings from './pages/listings';
import Jobs from './pages/jobs';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import AboutUs from './pages/about';
// import { GoogleOAuthProvider } from '@react-oauth/google'; // remove for now if unused
import ContactUsPage from './pages/Contact'; // make sure this path/export matches

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* No @import here — use <link> tags in index.html or Helmet instead */

  /* Optional local faces (keep only if you actually use them) */
  @font-face {
    font-family: 'Hagrid';
    src: url('/Hagrid-Regular-trial.ttf') format('truetype');
    font-display: swap;
  }
  @font-face {
    font-family: 'Telegraf';
    src: url('/telegraf.otf') format('opentype');
    font-display: swap;
  }

  body {
    margin: 0;
    padding: 0;
    /* keep the site white and let components color their sections */
    background-color: #ffffff;
    color: #111827;
    font-family: 'Manrope', 'Noto Sans', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  }

  .quill-content ul { list-style: disc; padding-left: 20px; margin: 10px 0; }
  .quill-content ol { list-style: decimal; padding-left: 20px; margin: 10px 0; }
  .quill-content li { margin-bottom: 5px; }
  .quill-content p { margin-bottom: 15px; line-height: 1.6; }
  .quill-content strong { font-weight: 700; }
`;

const App = () => {
  return (
    <HelmetProvider>
      {/* If you’d rather inject fonts here instead of index.html: */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;700;800&family=Noto+Sans:wght@400;500;700;900&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      {/* Remove OAuth wrapper if you’re not using it yet */}
      {/* <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}> */}
      <Router>
        <GlobalStyle />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/listings" element={<Listings />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/contact" element={<ContactUsPage />} />
        </Routes>
        <Footer />
      </Router>
      {/* </GoogleOAuthProvider> */}
    </HelmetProvider>
  );
};

export default App;
